import { DocumentedComponent } from "./DocumentedComponent";

export type SearchTermHighlightProps = {
    text: string;
    searchTerm: string;
    className?: string;
};

const SearchTermHighlight: React.FC<SearchTermHighlightProps> = ({text, searchTerm, className}) => {
    const startIndex = text.toLowerCase().indexOf(searchTerm.toLowerCase());

    if (startIndex === -1) return <span>{text}</span>;

    const endIndex = startIndex + searchTerm.length;
    return <span className={className}>
        {text.slice(0, startIndex)}
        <mark>{text.slice(startIndex, endIndex)}</mark>
        {text.slice(endIndex, text.length)}
    </span>;
};

(SearchTermHighlight as DocumentedComponent).metadata = {
    description: "Highlights the provided search term within text.  The text is rendered within a span, with all matches of the search term highlighted using <mark> tags.",
    attributes: [
        { name: "text", description: "The text to search within.  Optional - no default.", type: "string" },
        { name: "searchTerm", description: "The search term to highlight.  Optional - no default.", type: "string" },
        { name: "className", description: "Additional CSS classes to apply to the text.  Optional - no default.", type: "string" },
    ]
};

export { SearchTermHighlight };